import { environment } from '../../environments/environment';
import { DataTarget, getApiBase, getDataTarget } from './data-target';

export type ClientEnv = 'PROD' | 'DEV';

export interface EnvironmentInfo {
  /** Which BUILD of the client is running (fixed at build time). */
  client: ClientEnv;
  /** Which DATABASE the client is talking to (chosen at runtime, see data-target.ts). */
  database: DataTarget;
  /** Client version from the build environment file. */
  clientVersion: string;
  /** Host the client was served from. */
  host: string;
  /** API path prefix requests are rewritten to for the selected database. */
  apiBase: string;
  /** True when the client build and the database are not the same environment. */
  isMixed: boolean;
  /** e.g. "DEV client · PROD database". */
  summary: string;
  /** Set only for the risky mix (DEV client on the PROD database); null otherwise. */
  warning: string | null;
}

/** The build's environment: driven by the build-time environment file (angular.json fileReplacements). */
export function getClientEnv(): ClientEnv {
  return environment.envLabel === 'PROD' ? 'PROD' : 'DEV';
}

export function getEnvironmentInfo(): EnvironmentInfo {
  const client = getClientEnv();
  const database = getDataTarget();
  const isMixed = client !== database;
  return {
    client,
    database,
    clientVersion: environment.appVersion,
    host: typeof window === 'undefined' ? '' : window.location.host,
    apiBase: getApiBase(database),
    isMixed,
    summary: `${client} client · ${database} database`,
    warning:
      client === 'DEV' && database === 'PROD'
        ? 'This DEV client is connected to the PROD database. Changes you make here are written to your live notes.'
        : null,
  };
}
